import { motion } from 'framer-motion';

export const GlassCard = ({ 
  children, 
  className = '', 
  hover = true,
  delay = 0 
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay }}
      whileHover={hover ? { y: -5 } : {}}
      className={`
        relative overflow-hidden rounded-lg
        bg-white/[0.03] backdrop-blur-sm
        border border-white/10
        transition-all duration-500
        ${hover ? 'hover:border-primary/50 hover:bg-white/[0.05] glow-border' : ''}
        ${className}
      `}
    >
      {children}
    </motion.div>
  );
};
